import type { WeeklyBreakdownProps } from '../../../context/types'

export const setInitialValues = (data: WeeklyBreakdownProps, weekSelected: number) => {
  const startIndex = (weekSelected - 1) * 7
  const weekDays = data.valorDias?.slice(startIndex, startIndex + 7) || []

  return {
    grouping: data.agrupamentoServico,
    descriptionId: Number(data.cdItemVenda),
    descriptionName: data.nmItemVenda,
    grossUnitValue: data.vlBrutoUnitario.toFixed(2),
    tax: data.contcVlrlFatPerimposto.toString(),
    totalQuantity: data.qtFaturadaPrevia.toString(),
    grossTotal: data.vlTotalBrutoPrevia.toFixed(2),
    netTotal: data.vlTotalLiquidaPrevia.toFixed(2),
    day1: weekDays[0]?.valor?.toString() || '0',
    day2: weekDays[1]?.valor?.toString() || '0',
    day3: weekDays[2]?.valor?.toString() || '0',
    day4: weekDays[3]?.valor?.toString() || '0',
    day5: weekDays[4]?.valor?.toString() || '0',
    day6: weekDays[5]?.valor?.toString() || '0',
    day7: weekDays[6]?.valor?.toString() || '0'
  }
}
